import React from 'react';
const SvgAddCircle: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.95 7.05a7 7 0 11-9.9 9.9 7 7 0 019.9-9.9M14 9.67v4.66M16.33 12h-4.66M5.017 6a9.934 9.934 0 000 12"
      />
    </svg>
  );
};
export default SvgAddCircle;
